import { lt } from '@mews/framework';
import { DialogFormProps, useDialogForm } from '@mews-commander/form';
import { OptimusProvider } from '@mews-commander/ui';
import { WithAccountId } from '@mews-commander/types';
import { FinancialDocumentPdfTemplateType, SimpleInvoice } from '@mews-commander/data-access';
import { SendReminderDialogContent } from '../forms/SendReminderDialogContent';
import { DEFAULT_ALLOWED_TYPES } from '../constants';

export interface UseSendReminderDialogProps
    extends Omit<DialogFormProps, 'active' | 'renderForm' | 'id'>,
        WithAccountId {
    onFormSuccess?: () => void;
    invoices: SimpleInvoice[];
    allowedInvoiceTemplateTypes: FinancialDocumentPdfTemplateType[];
    ownerEmails: string[];
}

export const useSendReminderDialog = ({
    title = lt('SendReminder'),
    accountId,
    invoices,
    allowedInvoiceTemplateTypes = DEFAULT_ALLOWED_TYPES,
    onFormSuccess,
    ownerEmails,
}: UseSendReminderDialogProps) => {
    const [renderDialog, toggleDialog] = useDialogForm({
        id: 'send-reminder-form',
        'data-test-id': 'send-reminder-form',
        title,
        subtitle: lt('SendReminderDescriptionText'),
        renderForm: (props) => (
            <SendReminderDialogContent
                {...props}
                invoices={invoices}
                accountId={accountId}
                allowedInvoiceTemplateTypes={allowedInvoiceTemplateTypes}
                ownerEmails={ownerEmails}
                onFormSuccess={onFormSuccess}
            />
        ),
        saveLabel: lt('Send'),
    });

    const renderSendReminderDialog = () => <OptimusProvider density="spacious">{renderDialog()}</OptimusProvider>;
    return [renderSendReminderDialog, toggleDialog] as const;
};
